import React from "react";

const Message = (props) => (
    <h2 className="center">{props.title}</h2>
);

export default Message;